import {
    CL_FM_FUNCTIONS_ARG_TYPES,
    CL_LOCALE,
    CL_FIELD_TYPES,
    CL_LANGUAGES,
    CL_SFM_TABS,
    VL_TIPOS_IDIOMA,
    VL_TIPOS_OBJETOS,
} from 'constants/App';
import { t } from 'utils/getLiteral';

export default class ServerListManager {
    constructor(api) {
        this.api = api;
    }

    getList = (list, lang) => {
        switch (list) {
            case CL_LOCALE:
                return Promise.resolve(this.getLocaleList());
            case CL_FIELD_TYPES:
                return Promise.resolve(this.getFieldTypes());
            case CL_LANGUAGES:
                return Promise.resolve(this.getLanguageList());
            case CL_SFM_TABS:
                return Promise.resolve(this.getSfmTabs());
            case CL_FM_FUNCTIONS_ARG_TYPES:
                return Promise.resolve(this.getFmFunctionArgTypes());
            default: {
                const getParams = {
                    lang,
                };

                if (list === VL_TIPOS_IDIOMA) {
                    getParams['fields[]'] = 'strISO639_1';
                } else if (list === VL_TIPOS_OBJETOS) {
                    getParams['fields[]'] = 'idObjectType';
                }

                return this.api
                    .getList(list, getParams)
                    .then((resp) => this.getListMapper(list, resp))
                    .catch((error) => {
                        throw error;
                    });
            }
        }
    };

    getListMapper = (list, result) => {
        let valueField = 'id';

        if (list === VL_TIPOS_IDIOMA) {
            valueField = 'strISO639_1';
        } else if (list === VL_TIPOS_OBJETOS) {
            valueField = 'idObjectType';
        }

        return result.map((item) => ({
            label: item.description,
            value: item[valueField],
        }));
    };

    getSfmTabs = () => [
        {
            label: t('cfm_label_sfm_intensity'),
            value: 'intensity',
        },
        {
            label: t('cfm_label_sfm_distribution'),
            value: 'distribution',
        },
        {
            label: t('cfm_label_sfm_conversion'),
            value: 'conversion',
        },
    ];

    getLocaleList = () =>
        [
            'es-ES',
            'en-GB',
            'en-US',
            'de-DE',
            'fr-FR',
            'it-IT',
            'pt-PT',
            'ru-RU',
            'pt-BR',
            'da-DK',
        ].map((value) => ({
            label: value,
            value,
        }));

    getFieldTypes = () =>
        [
            'text',
            'list',
            'multivalue',
            'int',
            'decimal',
            'currency',
            'datetime',
            'bit',
            'percentage',
        ].map((ty) => ({
            label: t(`cfm_label_type_${ty}`),
            value: ty,
        }));

    getLanguageList = () => [
        {
            label: t('cfm_label_spanish'),
            value: 'es-es',
        },
        {
            label: t('cfm_label_en_uk'),
            value: 'en-gb',
        },
        {
            label: t('cfm_label_ca_es'),
            value: 'ca-es',
        },
        {
            label: t('cfm_label_en_us'),
            value: 'en-us',
        },
        {
            label: t('cfm_label_fr'),
            value: 'fr-fr',
        },
        {
            label: t('cfm_label_it'),
            value: 'it-it',
        },
        {
            label: t('cfm_label_pt'),
            value: 'pt-pt',
        },
        {
            label: t('cfm_label_ru'),
            value: 'ru-ru',
        },
        {
            label: t('cfm_label_pt_br'),
            value: 'pt-br',
        },
        {
            label: t('cfm_label_de'),
            value: 'de-de',
        },
        {
            label: t('cfm_label_da'),
            value: 'da-dk',
        },
    ];

    getFmFunctionArgTypes = () => [
        {
            label: 'boolean',
            value: 'boolean',
        },
        {
            label: 'number',
            value: 'number',
        },
        {
            label: 'object',
            value: 'object',
        },
        {
            label: 'string',
            value: 'string',
        },
        {
            label: 'string_array',
            value: 'string_array',
        },
    ];
}
